<template>
    <main>
        <limitless-page-header></limitless-page-header>
        <div class="content">
            <b-card no-body>
                <b-card-header>
                    <b-form-group>
                        <b-form-checkbox v-model="filter.includeBlue">Visa även gamla från blå</b-form-checkbox>
                    </b-form-group>
                </b-card-header>
                <data-list-table
                    responsive
                    :data-provider="dataProvider"
                    :fields="fields"
                    :filter="filter"
                >
                    <template #cell(id)="{ value }">
                        <router-link :to="{ name: 'shipping.complaints.view', params: { id: value } }">{{ value }}</router-link>
                    </template>
                </data-list-table>
            </b-card>
        </div>
    </main>
</template>

<script>

import { formatDateTime } from '@services/Helpers';
import DataListTable from '@components/Datatable/DataListTable.vue';
import ShippingComplaintRepository from '@services/repositories/ShippingComplaintRepository';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader.vue';

export default {
    components: { LimitlessPageHeader, DataListTable },
    data() {
        return {
            fields: [
                {
                    key: 'created_at',
                    label: 'Datum',
                    formatter: formatDateTime,
                },
                {
                    key: 'id',
                    label: 'Nr',
                },
                {
                    key: 'service_type',
                    label: 'Tjänst',
                },
                {
                    key: 'external_no',
                    label: 'Ext. nr',
                },
                {
                    key: 'external_no',
                    label: 'Ext. nr',
                },
                {
                    key: 'parcel_number',
                    label: 'Kollinr',
                },
                {
                    key: 'reference',
                    label: 'Sändningsref',
                },
                {
                    key: 'status_label',
                    label: 'Status',
                },
            ],
            filter: {
                includeBlue: false,
            },
        };
    },
    methods: {
        dataProvider(ctx) {
            if (!ctx) {
                return {};
            }

            const repository = new ShippingComplaintRepository();
            const complaints = repository
                .setPerPage(ctx.perPage)
                .setCurrentPage(ctx.currentPage);

            if (!ctx.filter.includeBlue) {
                complaints.where('service_type[operator]', '!=')
                    .where('service_type[value]', 'PN-BLUE');
            }

            return complaints.run();
        },
    },
};
</script>
